
import { supabase } from '../../supabase';
import { toast } from 'sonner';

// Get security token for upload authentication
export async function getSecurityToken(userId: string): Promise<{ token: string; timestamp: number } | null> {
  const timestamp = new Date().getTime();
  
  try {
    console.log('Requesting security token for upload...');
    console.log(`User ID: ${userId}, Timestamp: ${timestamp}`);
    
    const { data: securityData, error: securityError } = await supabase.functions.invoke('generate-upload-token', {
      body: { userId, timestamp },
    });
    
    console.log('Response from token function:', securityData || securityError);
    
    if (securityError) {
      console.error('Error invoking security token function:', securityError);
      toast.error('Security verification failed', {
        description: securityError.message || 'Could not verify upload request. Please try again.'
      });
      return null;
    }
    
    if (!securityData?.token) {
      console.error('No token received from security function:', securityData);
      toast.error('Security verification incomplete', {
        description: 'Upload token could not be generated'
      });
      return null;
    }
    
    console.log('Security token received, proceeding with upload...');
    return { token: securityData.token, timestamp };
  } catch (tokenError) {
    console.error('Error during token generation:', tokenError);
    toast.error('Upload process error', {
      description: 'An error occurred during the security verification process'
    });
    return null;
  }
}
